import React from 'react';
import '../styles/Specs.css';

interface Spec {
  label: string;
  value: string;
}

const specs: Spec[] = [
  { label: 'Height', value: '11 inches (28 cm)' },
  { label: 'Base Diameter', value: '6 inches (15 cm)' },
  { label: 'Weight', value: '~6 lbs (2.7 kg)' },
  { label: 'Display', value: '5.7" LCD Touchscreen, 1920x1080' },
  { label: 'Cameras', value: 'Dual High-Res Stereo' },
  { label: 'Microphones', value: '6 Far-Field Array' },
  { label: 'Speakers', value: 'Stereo Pair' },
  { label: 'Processor', value: 'ARM-Based SoC' },
  { label: 'Operating System', value: 'Linux' },
  { label: 'Connectivity', value: 'Wi-Fi & Bluetooth' },
  { label: 'Motors', value: '3 DC Motors (Belt Drive)' },
  { label: 'Degrees of Freedom', value: '3 Axes (Pitch, Yaw, Roll)' },
  { label: 'Touch Sensors', value: 'Capacitive Head Touch' },
  { label: 'Power', value: 'AC Adapter + Optional Battery (~30 min)' },
  { label: 'Retail Price', value: '$899 USD' },
];

const Specs: React.FC = () => {
  return (
    <section id="specs" className="specs">
      <div className="specs__container">
        <h2 className="section-title">Technical Specifications</h2>
        <p className="section-subtitle">
          Small in size, big in technology
        </p>

        <div className="specs__body-diagram">
          <div className="specs__robot">
            <div className="specs__robot-head">
              <div className="specs__robot-eye" />
            </div>
            <div className="specs__robot-torso" />
            <div className="specs__robot-base" />
          </div>
          <div className="specs__robot-labels">
            <div className="specs__robot-label specs__robot-label--head">
              <span>Head</span> 5.7" LCD + Cameras + Mic Array
            </div>
            <div className="specs__robot-label specs__robot-label--torso">
              <span>Torso</span> ARM SoC + Speakers + Touch
            </div>
            <div className="specs__robot-label specs__robot-label--base">
              <span>Base</span> 3 DC Motors + Power
            </div>
          </div>
        </div>

        <div className="specs__table">
          {specs.map((spec, index) => (
            <div key={index} className="specs__row">
              <span className="specs__label">{spec.label}</span>
              <span className="specs__value">{spec.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specs;
